<template>
  <div class="modal-wrapper">
    <div class="modal-dialog">
      <div class="modal-content">
        <div :hidden="!requestError" class="alert alert-danger" role="alert">
          Ocorreu um erro ao enviar a requisição, tente novamente!
        </div>
        <div :hidden="!requestSuccess" class="alert alert-success" role="alert">
          O contrato foi enviado com sucesso!
        </div>
        <div class="modal-header">
          <h4 class="modal-title">
            <p>CONFIRMAÇÃO DOS DADOS</p>
          </h4>
        </div>

        <div class="modal-body">
          <table>
            <th>
              <p> DADOS DO ALUNO </p>
            </th>
            <tr>
              <th>Nome do Aluno: </th> {{ digitalContractData['user']['name'] }}
            </tr>
            <tr>
              <th>CPF: </th> {{ digitalContractData['user']['cpf'] }}
            </tr>
            <tr>
              <th>Data de Nascimento: </th> {{ digitalContractData['user']['bornDate'] }}
            </tr>
            <tr>
              <th>Estado Civil: </th> {{ digitalContractData['user']['maritalStatus'] }}
            </tr>
            <tr>
              <th>Rua: </th> {{ digitalContractData['user']['street'] }}
            </tr>
            <tr>
              <th>Complemento: </th> {{ digitalContractData['user']['complement'] }}
            </tr>
            <tr>
              <th>Bairro: </th> {{ digitalContractData['user']['neighborhood'] }}
            </tr>
            <tr>
              <th>Cidade: </th> {{ digitalContractData['user']['city'] }}
            </tr>
            <tr>
              <th>Estado: </th> {{ digitalContractData['user']['state'] }}
            </tr>
            <tr>
              <th>CEP: </th> {{ digitalContractData['user']['cep'] }}
            </tr>
            <tr>
              <th>Email: </th> {{ digitalContractData['user']['email'] }}
            </tr>
            <tr>
              <br>
            </tr>
            <th>
              <p> DADOS DO GARANTIDOR </p>
            </th>
            <tr>
              <th>Nome do Garantidor: </th> {{ guarantorData['name'] || '-' }}
            </tr>
            <tr>
              <th>CPF do Garantidor: </th> {{ guarantorData['cpf'] || '-' }}
            </tr>
            <tr>
              <th>Estado Civil: </th> {{ guarantorData['maritalStatus'] || '-' }}
            </tr>
            <tr>
              <th>Rua: </th> {{ guarantorData['street'] || '-' }}
            </tr>
            <tr>
              <th>Complemento: </th> {{ guarantorData['complement'] || '-' }}
            </tr>
            <tr>
              <th>Bairro: </th> {{ guarantorData['neighborhood'] || '-' }}
            </tr>
            <tr>
              <th>Cidade: </th> {{ guarantorData['city'] || '-' }}
            </tr>
            <tr>
              <th>Estado: </th> {{ guarantorData['state'] || '-' }}
            </tr>
            <tr>
              <th>CEP: </th> {{ guarantorData['cep'] || '-' }}
            </tr>
            <tr>
              <th>Email: </th> {{ guarantorData['email'] || '-' }}
            </tr>
            <tr>
              <th>Telefone: </th> {{ guarantorData['phone'] || '-' }}
            </tr>
            <tr>
              <br>
            </tr>
            <th>
              <p> DADOS DA INSTITUIÇÃO </p>
            </th>
            <tr>
              <th> Nome da Instituição: </th> {{ digitalContractData['institution']['name'] }}
            </tr>
            <tr>
              <th> CNPJ: </th> {{ digitalContractData['institution']['cnpj'] }}
            </tr>
            <tr>
              <th> Rua: </th>
              {{ digitalContractData['institution']['street'] }},
              {{ digitalContractData['institution']['number'] }}
            </tr>
            <tr>
              <th> Bairro: </th> {{ digitalContractData['institution']['neighborhood'] }}
            </tr>
            <tr>
              <br>
            </tr>
            <th>
              <p> DADOS DE PAGAMENTO </p>
            </th>
            <tr>
              <th> Número do Contrato: </th> {{ digitalContractData['billingData']['contractNumber'] }}
            </tr>
            <tr>
              <th> Dia de Vencimento: </th> {{ digitalContractData['billingData']['dueDay'] }}
            </tr>
            <tr>
              <th> Mensalidades: </th> {{ digitalContractData['billingData']['installments'] }}
            </tr>
            <tr>
              <th> Mensalidades após: </th>
              {{ digitalContractData['billingData']['afterCourseInstallments'] }}
            </tr>
            <tr>
              <th> Mensalidades durante: </th> {{ digitalContractData['billingData']['duringCourseInstallments'] }}
            </tr>
            <tr>
              <th> Valor da Mensalidade: </th> {{ digitalContractData['billingData']['installmentValue'] }}
            </tr>
            <tr>
              <th> Valor durante o curso: </th> {{ digitalContractData['billingData']['installmentValueDuringCourse'] }}
            </tr>
            <tr>
              <th> Valor após o curso: </th> {{ digitalContractData['billingData']['installmentValueAfterCourse'] }}
            </tr>
            <tr>
              <th> Data do primeiro vencimento: </th> {{ digitalContractData['billingData']['firstBillDueDate'] }}
            </tr>
            <tr>
              <th class="th-spacing">
                Primeira cobrança após curso:
              </th>
              {{ digitalContractData['billingData']['firstBillAfterCourseNumber'] }}
            </tr>
            <tr>
              <th> Semestre: </th> {{ digitalContractData['billingData']['semester'] }}
            </tr>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="$emit('close')">
            Fechar
          </button>

          <button :disabled="disabled" type="button" class="btn btn-primary" @click="sendDigitalContract">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .modal-body{
    overflow-y: auto;
    max-height: 80vh;
  }
  .th-spacing{
    padding-right: 20px;
  }
</style>

<script>
import ParcelamentoService from 'services/ParcelamentoService';

export default {
  data() {
    return {
      requestError: false,
      requestSuccess: false,
      disabled: false,
    };
  },
  props: {
    paymentPlan: {
      type: Object,
      default: () => {},
    },
    digitalContractData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    guarantorData() {
      return this.digitalContractData.guarantorData || {};
    },
  },
  methods: {
    sendDigitalContract() {
      ParcelamentoService.confirmDigitalContract(this.paymentPlan)
        .then(() => {
          this.requestSuccess = true;
          this.disabled = true;
        }).catch(() => {
          this.requestError = true;
        });
    },
  },
};
</script>
